<template>
  <v-col class="pa-6">
    <div v-if="!viewingMessage">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            class="input"
            label="Search..."
            prepend-inner-icon="mdi-magnify"
            rounded
            v-model="search"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-row class="ma-0 mt-4" justify="center" justify-md="start">
            <v-select
              style="max-width: 240px"
              class="input ma-0 pa-0"
              label="Status Type"
              v-model="selectedType"
              :items="statusTypes"
              rounded
              :hide-details="true"
            ></v-select>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-data-table
          no-data-text="No groups yet"
          style="width: 100%"
          :headers="headers"
          :items="filteredMessages"
          :items-per-page="10"
          class="elevation-1 ml-4 mr-8"
        >
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon
                color="#4390c0"
                @click="
                  selectedMessage = item;
                  newStatus = item.status;
                  settingStatus = true;
                "
                >mdi-pencil</v-icon
              >
            </td>
            <td>
              <v-icon
                color="#4390c0"
                @click="
                  selectedMessage = item;
                  viewingMessage = true;
                "
                >mdi-eye</v-icon
              >
            </td>
          </template>
        </v-data-table>
      </v-row>
    </div>
    <div v-if="viewingMessage">
      <v-row class="ma-0">
        <v-btn @click="goBack()" rounded dark width="240px" color="#e022d1">
          Back
        </v-btn>
      </v-row>
      <v-card class="pa-8 mt-4" color="card" style="border-radius: 10px">
        <v-col cols="12" class="pa-0 mb-7">
          <v-row class="ma-0">
            <v-col class="pa-0" cols="12" md="6">
              <v-row class="ma-0 mb-3">
                <h3 class="white-color">Date Reported:</h3>
                <p class="white-color mx-2 mt-1">
                  {{ selectedMessage.dateReportedFormatted }}
                </p>
              </v-row>
              <v-row class="ma-0 mb-3">
                <h3 class="white-color">Reported User:</h3>
                <p class="white-color mx-2 mt-1">
                  {{ selectedMessage.reportedUser }}
                </p>
              </v-row>
              <v-row class="ma-0 mb-3">
                <h3 class="white-color">Reported User Email:</h3>
                <p class="white-color mx-2 mt-1">
                  {{ selectedMessage.reportedUserEmail }}
                </p>
              </v-row>
              <v-row class="ma-0 mb-3">
                <h3 class="white-color">Reported User Nickname:</h3>
                <p class="white-color mx-2 mt-1">
                  {{ selectedMessage.userNickname }}
                </p>
              </v-row>
              <v-row class="ma-0 mb-3">
                <h3 class="white-color">Reported Usertype:</h3>
                <p class="white-color mx-2 mt-1">
                  {{ selectedMessage.userType }}
                </p>
              </v-row>
              <v-row class="ma-0 mb-3">
                <h3 class="white-color">Reporting User:</h3>
                <p class="white-color mx-2 mt-1">
                  {{ selectedMessage.reportingBy }}
                </p>
              </v-row>
              <v-row class="ma-0 mb-3">
                <h3 class="white-color">Reporting User Email:</h3>
                <p class="white-color mx-2 mt-1">
                  {{ selectedMessage.reportingByEmail }}
                </p>
              </v-row>
              <v-row class="ma-0 mb-3">
                <h3 class="white-color">Group:</h3>
                <p class="white-color mx-2 mt-1">
                  {{ selectedMessage.group.name }}
                </p>
              </v-row>
            </v-col>
            <v-col class="pa-0" cols="12" md="6">
              <v-row class="ma-0 relative">
                <h4 style="color: white">{{ selectedMessage.message.date }}</h4>
              </v-row>
              <v-row class="ma-0 relative">
                <v-card
                  rounded
                  class="pa-3 message-card"
                  :class="{
                    doctorMessage: selectedMessage.userType == 'Doctor',
                  }"
                >
                  <v-row class="ma-0" justify="start">
                    <h4>{{ selectedMessage.baseMessage }}</h4>
                  </v-row>
                  <v-row
                    v-if="
                      selectedMessage.message.fileName &&
                      selectedMessage.message.fileType == 'image/png'
                    "
                    class="ma-0"
                    justify="start"
                  >
                    <img
                      :src="selectedMessage.message.url"
                      class="fileImage my-2"
                    />
                  </v-row>
                  <v-row
                    v-if="selectedMessage.message.fileName"
                    class="ma-0"
                    justify="start"
                  >
                    <h5 class="mt-2 fileText">
                      {{ "-" + selectedMessage.message.fileName }}
                    </h5>
                  </v-row>
                  <v-row
                    v-if="selectedMessage.message.fileName"
                    class="ma-0"
                    justify="start"
                  >
                    <h5
                      class="pink-color pointer"
                      @click="viewFile(selectedMessage.message.url)"
                    >
                      View File
                    </h5>
                  </v-row>
                  <div
                    v-if="
                      selectedMessage.message.fileName &&
                      selectedMessage.message.voiceRecording
                    "
                  >
                    <v-row class="ma-0">
                      <v-icon
                        v-if="!isPlaying"
                        @click="playAudio(selectedMessage.message)"
                        size="40"
                        color="#4390c0"
                      >
                        mdi-play-circle
                      </v-icon>
                      <v-icon
                        v-if="isPlaying"
                        @click="pauseAudio()"
                        size="40"
                        color="#4390c0"
                      >
                        mdi-pause-circle
                      </v-icon>
                      <v-icon
                        v-if="isPlaying"
                        @click="resetAudio()"
                        size="40"
                        color="#4390c0"
                      >
                        mdi-skip-previous-circle
                      </v-icon>

                      <div class="bars mb-5 mx-3">
                        <div
                          v-for="n in 5"
                          :key="n"
                          class="bar"
                          :class="{ active: isPlaying }"
                        ></div>
                      </div>
                    </v-row>
                    <!-- <v-row v-if="message.fileName" class="ma-0" justify="start">
                                        <h5 class="pink-color" @click="viewFile(message.url)">View File</h5>
                                    </v-row> -->
                  </div>
                  <!-- <v-row class="ma-0 mt-2 relative">
                                <h5 style="color: black">{{
                                    message.user || 'User was removed'
                                }}</h5>
                            </v-row> -->
                </v-card>
              </v-row>
              <v-row class="ma-0 relative">
                <h4 style="color: white">{{ selectedMessage.message.time }}</h4>
              </v-row>
              <v-row class="ma-0 mt-3">
                <v-btn
                  @click="viewGroup()"
                  rounded
                  dark
                  width="240px"
                  color="#e022d1"
                >
                  View Group
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </div>
    <div></div>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="black"
            dark
            depressed
            large
            style="border-radius: 24px"
            @click="promptDialog = false"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="settingStatus" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <!-- <v-icon size="96" color="green"> mdi-check-circle </v-icon> -->
          <div class="body-1 text-h6">Set Message Status</div>
        </v-card-text>
        <v-row justify="center">
          <v-select
            style="max-width: 240px"
            class="input ma-0 my-6 pa-0"
            label="Status Type"
            v-model="newStatus"
            :items="statusTypes"
            rounded
            :hide-details="true"
            clearable
          ></v-select>
        </v-row>
        <v-row justify="center" class="mt-6">
          <v-btn
            color="black"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="settingStatus = false"
          >
            CANCEL
          </v-btn>
          <v-btn
            color="blue"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="updateStatus()"
          >
            Update
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate />
      </v-overlay>
    </v-row>
  </v-col>
</template>

<script>
import GroupView from "../components/GroupView.vue";

import {
  collection,
  getDocs,
  where,
  getFirestore,
  query,
  getDoc,
  doc,
  onSnapshot,
  updateDoc,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      headers: [
        {
          text: "Date Reported",
          value: "dateReportedFormatted",
        },
        {
          text: "Message",
          value: "baseMessage",
        },
        {
          text: "Reported Email",
          value: "reportedUserEmail",
        },
        {
          text: "Reporting Email",
          value: "reportingByEmail",
        },
        { text: "Action", value: "action" },
      ],
      search: "",
      clients: [],
      doctors: [],
      settingStatus: false,
      selectedMessage: null,
      statusTypes: ["Pending", "Handled"],
      selectedType: "Pending",
      newStatus: "",
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      viewingMessage: false,
      messages: [],
      isPlaying: false,
      unsubscribeDoctors: null,
      unsubscribeClients: null,
      unsubscribeGroups: null,
    };
  },
  components: {
    GroupView,
  },
  async created() {
    let res = await this.getClients();
    let res2 = await this.getDoctors();
    let res3 = await this.getGroups();
    this.getMessages();
  },
  methods: {
    getGroups() {
      try {
        this.loading = true;
        const q = query(collection(db, "groups"));

        // Real-time listener
        this.unsubscribeGroups = onSnapshot(q, (snapshot) => {
          this.groups = [];

          snapshot.forEach((groupDoc) => {
            let tempGroup = groupDoc.data();
            tempGroup.id = groupDoc.id;

            // Format created date
            if (tempGroup.dateCreated?.seconds) {
              tempGroup.date = new Date(tempGroup.dateCreated.seconds * 1000)
                .toISOString()
                .substring(0, 10);
            } else {
              tempGroup.date = "";
            }

            // Identify creator (client or doctor)
            let createdByClient = this.clients.find(
              (client) => client.id === tempGroup.createdBy?.userID
            );

            if (createdByClient) {
              tempGroup.createdBy = createdByClient;
              tempGroup.createdByName =
                createdByClient.firstName + " " + createdByClient.lastName;
              tempGroup.createdByEmail = createdByClient.email;
            } else {
              let createdByDoctor = this.doctors.find(
                (doctor) => doctor.id === tempGroup.createdBy?.userID
              );

              if (createdByDoctor) {
                tempGroup.createdBy = createdByDoctor;
                tempGroup.createdByName =
                  createdByDoctor.name + " " + createdByDoctor.surname;
                tempGroup.createdByEmail = createdByDoctor.email;
              }
            }

            // Default status
            if (!tempGroup.status) {
              tempGroup.status = "Pending";
            }

            this.groups.push(tempGroup);
          });

          this.loading = false;
        });
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
        this.promptMessage = "An error occurred while fetching the groups!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    getClients() {
      try {
        const q = query(collection(db, "clients"));
        this.loading = true;

        // Subscribe to real-time updates
        this.unsubscribeClients = onSnapshot(q, (querySnapshot) => {
          this.clients = []; // Clear previous list

          querySnapshot.forEach((docSnap) => {
            const tempClient = docSnap.data();
            tempClient.id = docSnap.id;
            this.clients.push(tempClient);
          });

          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        console.error("Error fetching clients:", error);
      }
    },
    getDoctors() {
      try {
        this.loading = true;
        const q = query(collection(db, "doctors"));

        // Subscribe to real-time updates
        this.unsubscribeDoctors = onSnapshot(q, (querySnapshot) => {
          this.doctors = [];

          querySnapshot.forEach((doctor) => {
            let tempDoctor = doctor.data();
            tempDoctor.id = doctor.id;

            this.doctors.push(tempDoctor);
          });

          this.loading = false;
        });
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
        this.promptMessage = "An error occurred while fetching the doctors!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async getMessages() {
      try {
        this.loading = true;
        let q = query(collection(db, "reportedMessages"));
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.messages = [];

        querySnapshot.docs.forEach((message) => {
          let tempMessage = message.data();
          tempMessage.id = message.id;

          tempMessage.dateReportedFormatted = new Date(
            tempMessage.dateReported.seconds * 1000
          )
            .toISOString()
            .substring(0, 10);

          tempMessage.baseMessage = tempMessage.message.message;

          if (!tempMessage.baseMessage) {
            tempMessage.baseMessage = tempMessage.message.fileName;
          }

          let reportingUser = this.clients.find(
            (client) => client.id == tempMessage.reportingUserID
          );
          if (reportingUser) {
            tempMessage.reportingBy =
              reportingUser.firstName + " " + reportingUser.lastName;
            tempMessage.reportingByEmail = reportingUser.email;
          } else {
            let reportingUser = this.doctors.find(
              (doctor) => doctor.id == tempMessage.reportingUserID
            );

            if (reportingUser) {
              tempMessage.reportingBy =
                reportingUser.name + " " + reportingUser.surname;
              tempMessage.reportingByEmail = reportingUser.email;
            }
          }

          let reportedUser = this.clients.find(
            (client) => client.id == tempMessage.userID
          );
          if (reportedUser) {
            tempMessage.reportedUser =
              reportedUser.firstName + " " + reportedUser.lastName;
            tempMessage.reportedUserEmail = reportedUser.email;
          } else {
            let reportedUser = this.doctors.find(
              (doctor) => doctor.id == tempMessage.userID
            );

            if (reportedUser) {
              tempMessage.reportedUser =
                reportedUser.name + " " + reportedUser.surname;
              tempMessage.reportedUserEmail = reportedUser.email;
            }
          }

          tempMessage.group = this.groups.find(
            (group) => group.id == tempMessage.groupID
          );

          if (!tempMessage.status) {
            tempMessage.status = "Pending";
          }

          this.messages.push(tempMessage);
        });
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
        this.promptMessage =
          "An error occured while fetching the reported messages!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async updateStatus() {
      this.settingStatus = false;

      try {
        this.loading = true;

        const consultRef = doc(db, "reportedMessages", this.selectedMessage.id);
        await updateDoc(consultRef, {
          status: this.newStatus,
        });
        this.loading = false;

        this.selectedMessage.status = this.newStatus;

        this.promptMessage = "Successfully updated status!";
        this.promptType = "success";
        this.promptDialog = true;
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
        this.promptMessage =
          "Something went wrong while updating the message's status, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    playAudio(message) {
      this.audio = new Audio(message.url);
      this.audio.play();
      this.isPlaying = true;
    },
    resetAudio() {
      if (this.audio) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.isPlaying = false;
      }
    },
    pauseAudio() {
      this.audio.pause();
      this.isPlaying = false;
    },
    goBack() {
      localStorage.removeItem("ViewedGroup");
      this.viewingMessage = false;
    },
    viewFile(url) {
      window.open(url, "_blank");
    },
    viewGroup() {
      this.$router.push({
        path: "/groups",
        query: {
          id: this.selectedMessage.groupID,
        },
      });
    },
  },
  computed: {
    filteredMessages() {
      return this.messages.filter((item) => {
        // Filter by status if selectedStatus is not null
        const matchesStatus =
          this.selectedType === null || item.status === this.selectedType;

        // Filter by search text
        const matchesSearch = Object.values(item).some((value) => {
          if (value !== null && value !== undefined) {
            return value
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase());
          }
          return false;
        });

        // Only return items that match both filters
        return matchesStatus && matchesSearch;
      });
    },
  },
  beforeUnmount() {
    if (this.unsubscribeDoctors) {
      this.unsubscribeDoctors();
    }

    if (this.unsubscribeClients) {
      this.unsubscribeClients();
    }

    if (this.unsubscribeGroups) {
      this.unsubscribeGroups();
    }
  },
};
</script>

<style scoped>
.card {
  background: linear-gradient(to right, #4390c0, black);
}
</style>
